import styled from '@emotion/styled';
import { AnimatePresence } from 'motion/react';

import { breakpoints } from '../theme/media';
import { Notification } from './Notification';
import { useNotificationsStore } from './notificationsStore';

export const NotificationsProvider = () => {
  const { notifications } = useNotificationsStore();

  return (
    <Root>
      <AnimatePresence>
        {notifications.map((notification) => (
          <Notification key={notification.id} notification={notification} />
        ))}
      </AnimatePresence>
    </Root>
  );
};

const Root = styled.div`
  position: fixed;
  bottom: 64px;
  left: 64px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoints.before.laptop} {
    top: 24px;
    left: 24px;
    right: 24px;
    bottom: auto;
  }
`;
